import * as React from 'react';
import { TrackingProvider } from './tracking-context.js';
import { useTracking } from './use-tracking.js';

function ImpressionTracker({
  section,
  children,
  trackingData = {}
}) {
  const [isInViewport, setIsInViewport] = React.useState(false);
  const ref = React.useRef(null);
  const hasImpressionAlreadyBeenLogged = React.useRef(false);
  const rootTrack = useTracking();
  const properties = {
    section,
    ...trackingData
  };
  React.useEffect(() => {
    function setupObserver() {
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        if (entry !== undefined && isInViewport !== entry.isIntersecting) {
          setIsInViewport(entry.isIntersecting);
        }
      }, {
        root: null,
        rootMargin: '0px',
        threshold: 0
      });
      if (ref?.current) {
        const wrappedDOMElements = Array.from(ref.current.childNodes);
        const firstVisibleElement = wrappedDOMElements.find(el => {
          if (!el) return false;
          return el.offsetParent !== null;
        });
        if (firstVisibleElement) {
          observer.observe(firstVisibleElement);
        }
      }
    }
    setupObserver();
  }, []);
  React.useEffect(() => {
    function track() {
      rootTrack('impression', properties);
    }
    if (isInViewport && !hasImpressionAlreadyBeenLogged.current) {
      track();
      hasImpressionAlreadyBeenLogged.current = true;
    }
  }, [isInViewport]);
  return /*#__PURE__*/React.createElement(TrackingProvider, {
    value: properties
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: {
      display: 'contents'
    }
  }, children));
}

export { ImpressionTracker };
